import type { ReactNode } from 'react';
import { Card } from '@/components/ui/card';

export interface StatCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  children?: ReactNode;
}

/** Use for a single headline metric on dashboards/overviews. */
// A sparkline passed as children should be aria-hidden or carry a text alternative.
export function StatCard({ label, value, hint, children }: StatCardProps) {
  return (
    <Card className="min-w-0 gap-1 p-4">
      <dl>
        <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</dt>
        <dd className="break-words text-3xl font-semibold tabular-nums tracking-tight">{value}</dd>
      </dl>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      {children}
    </Card>
  );
}
